export type ColumnConfigModel = { [columnField: string]: Record<string, unknown> }

export const getColumnConfig = <T extends Record<string, unknown>>(
  model: ColumnConfigModel | undefined,
  field: string,
): T | undefined => {
  return model?.[field] as T | undefined
}
